import React, { useState, useEffect, useCallback } from "react"
import MyModal from "../MyModal"
import Input from "../Input"
import actionHelper from "../../lib/actionHelper"
import { toast } from "react-toastify"
import { createRankSystem } from "../../services/ranksystemApis"
import { useSocket, useSocketEvent } from "../../contexts/SocketContext"

const CreateRankSystemModal = ({ user, isOpen, toggleModal }) => {
    const { isConnected, sendMessage } = useSocket()

    const [price, setPrice] = useState(null)

    const submitHandler = (e) => {
        e.preventDefault()

        const form = new FormData(e.target)

        const data = {
            templateName: form.get("template-name"),
            confuser: form.get("username"),
            confpass: form.get("password"),
            information: form.get("information"),
        }
        actionHelper({
            confirmation: {
                label: `مقدار ${price} از حساب شما کم میشود`,
                actionLabel: "ساخت رنک سیستم",
                color: "success",
            },
            callback: () => createRankSystem(data),
            texts: {
                success: "رنک سیستم با موفقیت ساخته شد",
                pending: "درحال ساخت رنک سیستم",
            },
        })
    }

    useSocketEvent(
        "ranksystemPrice",
        useCallback((data) => {
            setPrice(data)
        }, []),
    )

    useEffect(() => {
        if (isConnected) {
            sendMessage("getRanksystemPrice")
        }
    }, [isConnected])

    return (
        <MyModal isOpen={isOpen} toggleModal={toggleModal} width="400px" height="400px">
            <div className="">
                <form onSubmit={submitHandler} className="m-2 ml-2">
                    <div className="mt-2">
                        <Input
                            type="text"
                            name="template-name"
                            label=" اسم تمپلیت بات"
                            placeholder="اسم تمپلیت"
                            required={true}
                        />
                    </div>
                    <div className="mt-2 grid grid-cols-2 gap-x-5">
                        <Input type="text" dir="ltr" label={"نام کاربری"} placeholder={"Username"} name={"username"} />

                        <Input type="password" dir="ltr" label={"پسورد"} placeholder={"Password"} name={"password"} />
                    </div>

                    <span id="rsPriceLabel">
                        <div class="show_info text-sm mt-2 text-green-400">{price?.toLocaleString("en-US")} تومان</div>
                    </span>

                    <Input type="text" dir="rtl" label={"توضیحات"} placeholder={"توضیحات"} name={"information"} />

                    <button type="submit" className="styled-button w-full mt-5">
                        ساخت رنک سیستم
                    </button>
                </form>
            </div>
        </MyModal>
    )
}

export default CreateRankSystemModal
